// this file added for individual by Bearer Web Developer
import React from 'react';
import styles from './personalDetailsForSignup.module.scss';
import { useAppState } from '../../../states/app-state';
import { Button } from '@mui/material';
import { observer, Observer } from 'mobx-react-lite';
import AvatarPart from './avatarPart';
import BearerDateField from '../../../components/fields/BearerDateField';
import BearerOptionsField from '../../../components/fields/BearerOptionsField';
import { validateEmail, validateFirstName, validateGender, validateLastName, validatePlaceName } from './validation';
import { TGender } from '../../../states/newCustomerState';
import BearerTextField from '../../../components/fields/BearerTextField';
import { SigninSituation } from '../../../states/signinState';


const PersonalDetailsForSignup: React.FunctionComponent = observer(() => {
    const appState = useAppState();
    const { login, signin, newCustomer } = appState;
    function checkvalidation() {
        let validation = true;
        validation = !validateFirstName(newCustomer.given_name)
            && !validateLastName(newCustomer.last_name)
            && !validateEmail(newCustomer.email_address)
            && !!newCustomer.birth_date && !!newCustomer.gender
        return validation;
    }
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (checkvalidation()) { 
            // Next Step - How did you hear about bearer?
            signin.setSituation(SigninSituation.HearAboutBearer);
        }
    }
    const handleClose = async () => {
        try {
            signin.setLoading(true);
            await login?.logout();
            signin.setLoading(false);
        } catch (error) {
            signin.setLoading(false);
            console.log(error);
        }
    }

    return (
        <div className={styles.main}>
            <div className={styles.header}>
                <h2>Personal Details</h2>
                <Button className={styles.back} disableRipple={true} onClick={handleClose}>
                    <img src="/back.png" alt="back" />
                </Button>
            </div>
            <form className={styles.form} onSubmit={handleSubmit}>
                <p>To complete your registration, please fill your information</p>
                <div className={styles.label_part}>
                    <label htmlFor="image">Profile Photo</label>
                </div>
                <AvatarPart />
                <div className={styles.inputs}>
                    <BearerTextField
                        colorStyle="white"
                        label="First Name"
                        placeholder="..."
                        type="text"
                        name="first-name"
                        value={newCustomer.given_name}
                        onChange={(e) => newCustomer.setGivenName(e.target.value)}
                        clear={() => { newCustomer.setGivenName('') }} // added by Bearer Web Developer
                        validator={validateFirstName}
                    />
                    <BearerTextField
                        colorStyle="white"
                        label="Last Name"
                        placeholder="..."
                        type="text"
                        name="last-name"
                        value={newCustomer.last_name}
                        onChange={(e) => newCustomer.setLastName(e.target.value)}
                        clear={() => { newCustomer.setLastName('') }}
                        validator={validateLastName}
                    />
                </div>
                <div className={styles.input}>
                    <BearerTextField
                        colorStyle="white"
                        label="Email address"
                        placeholder="email@example.com"
                        type="email"
                        name="email"
                        value={newCustomer.email_address}
                        onChange={(e) => newCustomer.setEmail(e.target.value)}
                        clear={() => { newCustomer.setEmail('') }} // added by Bearer Web Developer
                        validator={validateEmail}
                    />
                </div>
                <div className={styles.inputs}>
                    <BearerOptionsField
                        label={'Gender'}
                        name="gender"
                        value={newCustomer.gender}
                        colorStyle="white"
                        options={[
                            { label: 'Male', value: 'Male' }, { label: 'Female', value: 'Female' },
                            { label: 'None-binary', value: 'None-binary' },
                            { label: 'Prefer not to say', value: 'Prefer not to say' },
                        ]}
                        onChange={(e) => newCustomer.setGender(e.target.value as TGender)}
                        validator={validateGender}
                    />
                    <BearerDateField
                        label={'Date of Birth'}
                        name="date-of-birth"
                        colorStyle="white"
                        value={newCustomer.birth_date}
                        onChange={(e) => newCustomer.setBirthDate(e.target.value)}
                        placeholder={''}
                        clear={() => { newCustomer.setBirthDate('') }}
                        validator={validatePlaceName}
                    />
                </div>
                <Observer>{() => {
                    return (
                        <>
                            <Button
                                type='submit'
                                className={styles.submit}
                                variant="text"
                                color="primary"
                                fullWidth
                                disabled={!checkvalidation()}
                                disableRipple={true}
                            >
                                Submit
                            </Button>
                        </>
                    )
                }}</Observer>
            </form>
        </div>
    )
});

export default PersonalDetailsForSignup;